module.exports = __webpack_public_path__ + "static/icons_web-03-9f981ca31f014eba01a61d66ba354a68.svg";